var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18180_90905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.001 0H6.00098C2.68727 0 0.000976562 2.68629 0.000976562 6V34C0.000976562 37.3137 2.68727 40 6.00098 40H34.001C37.3147 40 40.001 37.3137 40.001 34V6C40.001 2.68629 37.3147 0 34.001 0Z",
    fill: "#05A8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001 34.2188C27.8538 34.2188 34.2197 27.8528 34.2197 20C34.2197 12.1472 27.8538 5.78125 20.001 5.78125C12.1482 5.78125 5.78223 12.1472 5.78223 20C5.78223 27.8528 12.1482 34.2188 20.001 34.2188Z",
    stroke: "white",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6104 33.1237L26.7979 31.9518L31.0166 19.7643C31.7979 17.8112 32.0322 16.2487 32.0322 14.9206C32.0322 12.4206 31.0166 10.2331 29.2197 9.99869C27.5791 9.84244 26.6416 11.4831 26.7197 12.4206C26.876 14.6862 29.1416 15.9362 29.1416 19.0612C29.1416 21.2487 27.7354 24.7643 26.7197 28.2018L21.876 13.5924L23.4385 13.5143C24.2197 13.5143 24.1416 12.3424 23.3604 12.4206C20.9385 12.6549 18.6729 12.5768 16.1729 12.4206C15.3916 12.3424 15.3916 13.5143 16.0947 13.5143L17.501 13.5924L19.6104 19.3737L16.6416 28.2799L11.7197 13.5924L13.2822 13.5143C13.9854 13.5143 13.9072 12.3424 13.2041 12.4206C10.9385 12.5768 8.75098 12.7331 8.2041 12.3424L7.5791 14.2174L14.1416 32.4206L16.0947 33.5143L20.3135 21.1706",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18180_90905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/wordpress.5123c395a1ba6377b1f69f60f2f94667.svg";
export { ForwardRef as ReactComponent };